// fueling invoices (Accounting) data hooks.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { FuelingInput, FuelingRecord } from '@technohull/shared';
import { api } from '../lib/api.js';

export function useFueling() {
  return useQuery({
    queryKey: ['fueling'],
    queryFn: () => api.get<{ records: FuelingRecord[] }>('/api/fueling'),
  });
}

export function useSaveFueling() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: FuelingInput) => api.post<{ id: number }>('/api/fueling', v),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['fueling'] }),
  });
}

export function useDeleteFueling() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post('/api/fueling/delete', { id }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['fueling'] }),
  });
}
